<!--打印机-->
<template>
    <div class="container">
        <div class="handleBox flex flex-c flex-b">
            <p class="navTitle">打印机 ></p>
            <div></div>
            <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="addDialog">添加</el-button>
        </div>

        <div class="table" style="height:calc( 100% - 100px )">
            <el-table :data="list" border :header-cell-style="{background:'#fafdff',color:'#606266',fontWeight:'normal'}" height="calc( 100% - 120px )">
                <el-table-column label="序号" width="70px" align="center">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="value" label="编号" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="success" size="small" plain @click="editDialog(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small" plain @click="delDialog(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="paging">
                <el-pagination @current-change="currChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>

        </div>

        <!--编辑-->
        <el-dialog :visible="dialogOpen" :title="dialogTitle" :close-on-click-modal="false" width="600px"  @close=" closeDialog " :append-to-body="true" :destroy-on-close="true">
            <div class="editBox">
                <el-form ref="edit" :model="formData" :rules="formRules" @submit.native.prevent label-width="70px">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="编号" prop="value">
                        <el-input v-model="formData.value"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="editBtn">
                <el-button type="primary" size="small" @click="submit()">保存</el-button>
                <el-button size="small" @click="closeDialog">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'Home',
        data: function () {
            return {
                curr: 1,
                row: 10,
                count: 0,
                pages: 1, //总页数
                dialogOpen: false,
                dialogTitle: '添加打印机',
                formData: {
                    password: ''
                },
                list: [],
                // 表单验证
                formRules: {
                    name: [{
                        required: true,
                        message: '请输入打印机名称',
                        trigger: 'change'
                    }], 
                    value: [{
                        required: true,
                        message: '请输入打印机编号',
                        trigger: 'change'
                    }]
                    
                },
                
            }
        },
        mounted: function () {
            this.getList()
        },
        methods: {
            getList: function () {
                this.http.post('/setting/getList', {
                    row: this.row,
                    curr: this.curr,
                    type: 'printer'
                }).then(res => {
                    this.list = res.list
                    this.curr = res.curr;
                    this.pages = res.pages;
                    this.count = res.count;
                })
            },

            //添加打印机
            addDialog: function () {
                this.formData = {}
                this.dialogTitle = '添加打印机'
                this.dialogOpen = true

            },
            //编辑打印机
            editDialog(data) {
                this.dialogTitle = '编辑打印机'
                this.dialogOpen = true
                var form = JSON.stringify(data)
                this.formData = JSON.parse(form)
            },

            //关闭弹窗
            closeDialog: function () {
                this.dialogOpen = false

                this.$refs['edit'].resetFields();
            },
            //删除打印机
            delDialog: function (id) {
                this.$confirm('确定要删除吗?', '提示').then(() => {
                    this.http.post('/setting/delete', {
                        id: id
                    }).then(res => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                }).catch(() => {
                    this.$message.info('已取消删除')
                });
            },

            //提交
            submit: function () {
                this.$refs['edit'].validate((valid) => {
                    if (valid) {
                        this.http.post('/setting/edit', {
                            id: this.formData.id ? this.formData.id : '',
                            type: 'printer',
                            name: this.formData.name,
                            value:this.formData.value
                        }).then(res => {
                            this.$message.success('保存成功')
                            this.dialogOpen = false
                            this.getList()
                        })
                    }
                })
            },
            currChange: function (curr) {
                this.curr = curr;
                this.getList()
            },
            sizeChange: function (row) {
                this.row = row;
                this.getList()
            },
        }
    }
</script>